module.exports = __webpack_public_path__ + "static/media/login-bg.53ad968c.jpg";